import { Controller } from '@hotwired/stimulus';

/**
 * Radio card controller — visually toggles card-style radio buttons.
 *
 * Usage:
 *   <div data-controller="radio-card">
 *     <label data-radio-card-target="card" data-action="click->radio-card#select">
 *       <input type="radio" name="..." value="..." class="sr-only" data-radio-card-target="input">
 *       ...
 *     </label>
 *   </div>
 */
export default class extends Controller {
  static targets = ['card', 'input'];

  static classes = ['selected', 'unselected'];

  connect() {
    this.refresh();
  }

  select(event) {
    const card = event.currentTarget;
    const input = card.querySelector('input[type="radio"]');
    if (!input) return;

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    this.refresh();
  }

  refresh() {
    const selectedClasses = this.hasSelectedClass
      ? this.selectedClasses
      : ['border-primary-500', 'bg-primary-50'];
    const unselectedClasses = this.hasUnselectedClass
      ? this.unselectedClasses
      : ['border-neutral-300'];

    this.cardTargets.forEach((card) => {
      const input = card.querySelector('input[type="radio"]');
      if (!input) return;

      if (input.checked) {
        card.classList.remove(...unselectedClasses);
        card.classList.add(...selectedClasses);
      } else {
        card.classList.remove(...selectedClasses);
        card.classList.add(...unselectedClasses);
      }
    });
  }
}
